// taken from https://bitbucket.opst.c1.vanguard.com/projects/VGIM/repos/vg-interaction-model.npm/browse/projects/vg-interaction-model/src/lib/components/vgim-address/services/codeone-zipcode/codeone-zipcode.service.ts
// usage example https://bitbucket.opst.c1.vanguard.com/projects/VGIM/repos/vg-interaction-model.npm/browse/projects/vg-interaction-model/src/lib/components/vgim-address/containers/vgim-address.component.ts#106
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface CodeOneZipCodeDetails {
  readonly allSuggestedCities: ReadonlyArray<string>;
  readonly isMatch: boolean;
  readonly suggestedState: string;
}

@Injectable({
  providedIn: 'root',
})
export class CodeOneZipCodeService {
  constructor(private http: HttpClient) {}

  getZipCodeDetails(zip: string): Observable<CodeOneZipCodeDetails> {
    return this.http.get<CodeOneZipCodeDetails>('vgim-validate-address-zip', { params: { zip } });
  }
}
